import React, { useState } from 'react';
import classNames from 'classnames';
import Highlight from 'src/components/Highlight';
import windowUtil from '../util/WindowUtil';
import { IoCopyOutline } from "react-icons/io5";
import { FaCheck } from "react-icons/fa";

import './CodeSamples.scss';

const names = {
    'html': 'HTML',
    'css': 'CSS',
    'javascript': 'JavaScript',
    'c#': 'C#',
    'cmd': 'CMD',
    'powershell': 'PowerShell'
}

const prettyName = (sample) => {
    return sample.name || names[sample.language] || sample.language
}

/**
 * Hightlighted code samples with language selector
 */
function CodeSamples({
    samples,
    copyButton
}) {

    const [active, setActive] = useState(0);
    const [copied, setCopied] = useState(false);

    const activeSample = samples[active];

    function handleClick() {
        windowUtil.copyToClipboard(activeSample.content.trim())
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
    }

    return <div className="code-samples">
        { samples.length > 1 && <div className={classNames("tabs")} role="radiogroup">
            { samples.map((sample, key) => {
                return <button
                    className={classNames("tab", { active: active === key})}
                    key={key}
                    onClick={() => setActive(key)}
                    role="radio"
                    aria-checked={active === key}
                >
                    {prettyName(sample)}
                </button>
            })}
        </div>}
        { samples.length === 1 && <div className="title">
            {prettyName(activeSample)}
        </div>}
        {activeSample && <div className="content">
            <Highlight language={activeSample.language}>
                {activeSample.content.trim()}                
            </Highlight>

            {copyButton && !copied && <button
                onClick={() => handleClick()}
                className="copy-button" > <IoCopyOutline className="button-icon" />
                <span>Copy</span></button>
            }

            {copyButton && copied && <div className="tick"><FaCheck className="button-icon" />
                <span>Copied</span></div>}
        </div>}
    </div>
}

export default CodeSamples;
